import * as React from "react"
import { Eye, EyeOff } from "lucide-react"

import { Input } from "@/components/ui/input"
import { cn } from "@/lib/utils"

/**
 * A password field with a show / hide (eye) button. Takes every Input prop;
 * `toggleClassName` colours the button for light pages (the default suits the
 * dark sign-in screens). A lock icon placed beside it at left-3 still lines up.
 */
const PasswordInput = React.forwardRef(({ className, toggleClassName, ...props }, ref) => {
  const [visible, setVisible] = React.useState(false)
  return (
    <div className="relative">
      <Input ref={ref} type={visible ? "text" : "password"} className={cn("pr-10", className)} {...props} />
      <button
        type="button"
        onClick={() => setVisible(v => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        className={cn("absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white", toggleClassName)}
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  )
})
PasswordInput.displayName = "PasswordInput"

export { PasswordInput }
